
export interface UserPermissionsResponse {
    userId: string;
    email: string;
    departmentId: string | null;
    departmentName: string | null;
    isSuperAdmin: boolean;
    roleIds: string[];
    moduleIds: string[];
    permissions: string[];
}

export type PermissionMatchMode = 'any' | 'all';

export const ALL_MODULES = 'ALL';
